<div class="mx-0 sm:mx-4 md:mx-10 lg:mx-16">
	<div class="bg-gray-75 text-center xl:px-40 lg:px-28 md:px-16 sm:px-6 px-4 py-8 max-w-screen-xl mx-auto">
		<div class="text-2xl text-gray">
			&OpenCurlyDoubleQuote;<slot name="quote" />&CloseCurlyDoubleQuote;
		</div>
		<hr class="w-2/12 bg-gray mx-auto my-5" style="height:2px;" />
		<!-- <div class="w-2/12 border-b border-gray border-solid m-auto mt-6 h-0" /> -->
		<div class="text-green text-2xl font-semibold">
			<slot name="personName" />
		</div>
		<div class="text-gray italic text-lg">
			<slot name="schoolName" />
		</div>
	</div>
</div>
